import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../config/api";
import { useLocation } from "../contexts/LocationContext";
import NearbyLocationsList from "../components/NearbyLocationsList";
import "./CinemaL.css";

const Cinemas = () => {
  const navigate = useNavigate();
  const { getLocationForAPI, formatDistance, selectedCity } = useLocation();

  const [cinemas, setCinemas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNearby = async () => {
      try {
        setLoading(true);

        const loc = getLocationForAPI();
        const baseFilters = { limit: 100, sortBy: "name" };
        if (loc) {
          baseFilters.latitude = loc.lat;
          baseFilters.longitude = loc.lng;
        }

        const mergeById = (acc, cinema) => {
          if (!cinema || !cinema.id) return acc;
          if (!acc.has(cinema.id)) {
            acc.set(cinema.id, cinema);
          } else if (cinema.distance != null) {
            const existing = acc.get(cinema.id);
            if (existing.distance == null || cinema.distance < existing.distance) {
              existing.distance = cinema.distance;
            }
          }
          return acc;
        };

        const merged = new Map();
        try {
          const geoRes = await api.getCinemas({ ...baseFilters });
          (Array.isArray(geoRes) ? geoRes : []).forEach((c) => mergeById(merged, c));
        } catch (e) {
          console.warn("Geo cinema fetch failed", e);
        }

        if (selectedCity?.name) {
          try {
            const cityRes = await api.getCinemas({ city: selectedCity.name, limit: 100, sortBy: "name" });
            (Array.isArray(cityRes) ? cityRes : []).forEach((c) => mergeById(merged, c));
          } catch (e) {
            console.warn("City-name cinema fetch failed", e);
          }
        }

        const sorted = Array.from(merged.values())
          .filter((c) => c.distance == null || c.distance <= 50)
          .sort((a, b) => {
            const da = a.distance ?? Number.POSITIVE_INFINITY;
            const db = b.distance ?? Number.POSITIVE_INFINITY;
            if (da !== db) return da - db;
            return String(a.name || "").localeCompare(String(b.name || ""));
          });

        setCinemas(sorted);
      } catch (e) {
        console.error("Nearby cinema fetch failed", e);
        setCinemas([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNearby();
  }, [selectedCity, getLocationForAPI]);

  if (loading) {
    return (
      <div className="container text-center py-5">
        <h5>Loading nearby cinemas...</h5>
      </div>
    );
  }

  return (
    <div className="cinema-list-page container py-4">
      <div className="cinema-page-header mb-4">
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 700,
            color: "#2f3192",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Nearby Cinemas {selectedCity?.name || "your location"}
        </h2>
      </div>

      {cinemas.length === 0 ? (
        <div className="text-center py-5">
          <h5>No cinemas found near the selected location</h5>
          <NearbyLocationsList />
        </div>
      ) : (
        <div className="cinema-grid">
          {cinemas.map((cinema) => (
            <div
              key={cinema.id}
              className="cinema-card"
              onClick={() => navigate(`/cinema/${cinema.id}`)}
            >
              <h5
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#1a1d5e",
                  margin: "0 0 4px",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {cinema.name}
              </h5>
              <p
                style={{
                  fontSize: "13px",
                  color: "#6c757d",
                  margin: "0 0 8px",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {cinema.address || cinema.location || "Address not available"}
              </p>
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#2E3192",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                📍 {formatDistance(cinema.distance)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Cinemas;
